// extracted by mini-css-extract-plugin
export var cell = "_5y-4";
export var headerCell = "_5y-2";
export var rowHeader = "_5y-3";
export var table = "_5y-1";
export var tableContainer = "_5y-0";